// @ts-ignore: autogenerated import
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ModuleType = 'AUDIO' | 'EMBED' | 'GALLERY' | 'IMAGE' | 'LIVESTREAM' | 'TEXT' | 'VIDEO' | 'VIDEO360';

export type SocialMediaAccountService = 'EMAIL' | 'FACEBOOK_PAGE' | 'INSTAGRAM' | 'SPOTIFY' | 'TWITTER' | 'YOUTUBE';

export type ArticlesByAuthorFragment = {
	__typename: 'ArticlesConnection';
	totalCount: number;
	edges: Array<{
		__typename: 'ArticlesEdge';
		node: {
			__typename: 'Article';
			modulesTypes: Array<ModuleType | null>;
			path: string;
			publicationDate: string | null;
			breakingnewsEnd: string | null;
			rowId: string;
			teaserText: string | null;
			title: string;
			image: {
				__typename: 'ModuleImage';
				altText: string | null;
				copyright: string | null;
				title: string | null;
				url: string | null;
			} | null;
		} | null;
	}>;
	pageInfo: { __typename: 'PageInfo'; endCursor: string | null; hasNextPage: boolean };
};

export type AuthorQueryVariables = Exact<{
	authorGuid: string;
	count: number;
	cursor?: string | null | undefined;
	withCacheTag: boolean;
}>;

export type AuthorQuery = {
	author: {
		__typename: 'Author';
		firstname: string;
		guid: string;
		slug: string | null;
		isActive: boolean | null;
		jobTitle: string | null;
		lastname: string;
		path: string | null;
		email: string | null;
		profilePicture: string | null;
		shareUrl: string | null;
		withCache?: Array<string> | null;
		description: string | null;
		socialMediaAccounts: Array<{
			__typename: 'SocialMediaAccount';
			accountName: string | null;
			service: SocialMediaAccountService | null;
			label: string | null;
		} | null> | null;
		trackingInfos: {
			__typename: 'TrackingInfos';
			customVars: Record<string, unknown> | null;
			pageVars: Record<string, unknown> | null;
			gtmVars: Record<string, unknown> | null;
		} | null;
	} | null;
	authorArticles: {
		__typename: 'ArticlesConnection';
		totalCount: number;
		edges: Array<{
			__typename: 'ArticlesEdge';
			node: {
				__typename: 'Article';
				modulesTypes: Array<ModuleType | null>;
				path: string;
				publicationDate: string | null;
				breakingnewsEnd: string | null;
				rowId: string;
				teaserText: string | null;
				title: string;
				image: {
					__typename: 'ModuleImage';
					altText: string | null;
					copyright: string | null;
					title: string | null;
					url: string | null;
				} | null;
			} | null;
		}>;
		pageInfo: { __typename: 'PageInfo'; endCursor: string | null; hasNextPage: boolean };
	} | null;
};

export type AuthorFetchMoreQueryVariables = Exact<{
	authorGuid: string;
	count: number;
	cursor?: string | null | undefined;
}>;

export type AuthorFetchMoreQuery = {
	authorArticles: {
		__typename: 'ArticlesConnection';
		totalCount: number;
		edges: Array<{
			__typename: 'ArticlesEdge';
			node: {
				__typename: 'Article';
				modulesTypes: Array<ModuleType | null>;
				path: string;
				publicationDate: string | null;
				breakingnewsEnd: string | null;
				rowId: string;
				teaserText: string | null;
				title: string;
				image: {
					__typename: 'ModuleImage';
					altText: string | null;
					copyright: string | null;
					title: string | null;
					url: string | null;
				} | null;
			} | null;
		}>;
		pageInfo: { __typename: 'PageInfo'; endCursor: string | null; hasNextPage: boolean };
	} | null;
};

export const ArticlesByAuthorFragmentDoc = {
	kind: 'Document',
	definitions: [
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ArticlesByAuthor' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticlesConnection' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'edges' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'node' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleItemResultsItem' } }],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'pageInfo' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ImageModule' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModuleImage' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'altText' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ArticleItemResultsItem' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'modulesTypes' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'path' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'breakingnewsEnd' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'teaserText' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'image' },
						selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageModule' } }] },
					},
				],
			},
		},
	],
} as unknown as DocumentNode<ArticlesByAuthorFragment, unknown>;
export const AuthorDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'Author' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'authorGuid' } },
					type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
					type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cursor' } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'withCacheTag' } },
					type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						alias: { kind: 'Name', value: 'author' },
						name: { kind: 'Name', value: 'authorByGuid' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'guid' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'authorGuid' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AuthorHeader' } },
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildAuthorStructuredData' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'guid' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'slug' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'path' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'profilePicture' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'socialMediaAccounts' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'service' } },
										],
									},
								},
								{ kind: 'Field', name: { kind: 'Name', value: 'shareUrl' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'trackingInfos' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'customVars' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'pageVars' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'gtmVars' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'withCache' },
									directives: [
										{
											kind: 'Directive',
											name: { kind: 'Name', value: 'include' },
											arguments: [
												{
													kind: 'Argument',
													name: { kind: 'Name', value: 'if' },
													value: { kind: 'Variable', name: { kind: 'Name', value: 'withCacheTag' } },
												},
											],
										},
									],
								},
							],
						},
					},
					{
						kind: 'Field',
						alias: { kind: 'Name', value: 'authorArticles' },
						name: { kind: 'Name', value: 'articlesByAuthor' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'guid' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'authorGuid' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticlesByAuthor' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'AuthorHeaderSocialMediaAccounts' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Author' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'socialMediaAccounts' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'label' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'service' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ImageModule' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModuleImage' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'altText' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ArticleItemResultsItem' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'modulesTypes' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'path' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'breakingnewsEnd' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'teaserText' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'image' },
						selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageModule' } }] },
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'AuthorHeader' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Author' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AuthorHeaderSocialMediaAccounts' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'profilePicture' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'BuildAuthorStructuredData' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Author' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'guid' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'jobTitle' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'path' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'shareUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'profilePicture' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'socialMediaAccounts' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'service' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ArticlesByAuthor' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticlesConnection' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'edges' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'node' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleItemResultsItem' } }],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'pageInfo' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
				],
			},
		},
	],
} as unknown as DocumentNode<AuthorQuery, AuthorQueryVariables>;
export const AuthorFetchMoreDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'AuthorFetchMore' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'authorGuid' } },
					type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
					type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Cursor' } },
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						alias: { kind: 'Name', value: 'authorArticles' },
						name: { kind: 'Name', value: 'articlesByAuthor' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'guid' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'authorGuid' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'count' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticlesByAuthor' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ImageModule' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModuleImage' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'altText' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ArticleItemResultsItem' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Article' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'modulesTypes' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'path' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'breakingnewsEnd' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'teaserText' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'image' },
						selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageModule' } }] },
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ArticlesByAuthor' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArticlesConnection' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'edges' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'node' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ArticleItemResultsItem' } }],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'pageInfo' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
				],
			},
		},
	],
} as unknown as DocumentNode<AuthorFetchMoreQuery, AuthorFetchMoreQueryVariables>;
